<script setup lang="ts">
import numWord from '~/common/num-word';
import { useMediaQueryStore } from '~/stores/mediaQuery';
import { useTimeCalculation } from '~/composition/useTimeCalculation';

const mediaStore = useMediaQueryStore();
const props = defineProps({
  countShops: {
    type: Number,
    default: 0,
  },
  merchantRating: {
    type: Number,
    default: 0,
  },
});
const isMobile = computed(
  () =>
    mediaStore.isMobile || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const storeRating = computed(() => {
  return numWord(
    props.countShops,
    ['', 'магазин', 'магазина', 'магазинов'],
    true
  );
});
const textRating = computed(() => {
  return isMobile.value ? '+' : '\u00A0и выше';
});
useTimeCalculation();
</script>

<template>
  <div v-if="countShops" class="rating-star-wrap">
    <p class="rating-star-title">{{ storeRating }} с</p>
    <div class="rating-star-info">
      <div class="rating-star-number">{{ props.merchantRating }}</div>
      <div class="rating-star-ratings">{{ textRating }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.rating-star-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  @include md-block {
    font-size: 13px;
  }
  @include lg-block {
    font-size: 14px;
    line-height: 20px;
  }

  .rating-star-title {
    margin-right: 4px;
  }

  .rating-star-info {
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 15px;
    position: relative;

    &:after {
      background-image: url('/static/images/icon/star-rating-20.svg');
      content: '';
      position: absolute;
      left: 0;
      top: 1px;
      width: 13px;
      height: 12px;
      background-position: center center;
      background-repeat: no-repeat;
      display: block;
    }

    @include lg-block {
      &:after {
        top: 2px;
        width: 15px;
        height: 14px;
      }
    }
  }
}
</style>
